import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { TenantThemeProvider } from './contexts/TenantThemeContext'
import { PendingDiscountsProvider } from './contexts/PendingDiscountsContext'
import { PendingNegConfsProvider } from './contexts/PendingNegConfsContext'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <TenantThemeProvider>
        <PendingDiscountsProvider>
          <PendingNegConfsProvider>
            <App />
          </PendingNegConfsProvider>
        </PendingDiscountsProvider>
      </TenantThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
